import React ,{ useEffect, useRef, useState } 
from "react";
import { FormProvider, useForm } from "react-hook-form";

import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import TextInput from "../../../components/forms/TextInput";
import { IFilterMessage, getDefaultFilterMessage } from "../../../models/interfaces/IFilterMessage";
import { typeDemandeMessageListMarques, typeDemandeMessageListNotices, typeReponseMessageList, validationMode } from "../../../config/helpers";
import CpntMultiSelect from "../../../components/CpntMultiSelect";

import { useFetchUtilisateurscalipseQuery } from "../../../redux/slice/api/staticData";
import CpntFilterButtons from "../../../components/CpntFilterButtons";


interface IProps {
  filter?: IFilterMessage;
  changeFilter: (data: IFilterMessage) => void;
}


//Arrive pas a faire passer unb param au parent...
const DemandesFilter: React.FC<IProps> = ({ filter, changeFilter }) => {

  const prevFilterRef = useRef<IFilterMessage | undefined>(filter);
  const [selectedIdstypeDemandes, setSelectedIdstypeDemandes] = useState<any[]>([]);
  const [selectedIdstypeReponses, setSelectedIdstypeReponses] = useState<any[]>([]);
  const [selectedIdsUtilisateurscalipse, setselectedIdsUtilisateurscalipse] = useState<any[]>([]);
  const { data: Utilisateurscalipse } = useFetchUtilisateurscalipseQuery(undefined, {
    refetchOnMountOrArgChange: true
  });
  useEffect(() => {

    // if (getValues("Message") !== filter?.Message) {
    //   setValue("Message",filter?.Message);
    // }

    if (JSON.stringify(prevFilterRef.current) !== JSON.stringify(filter) || getValues() !== JSON.stringify(filter)) {
      reset(filter);
    }

    prevFilterRef.current = filter;
  }, [filter]);
  
  const formMethods = useForm<IFilterMessage>({
    defaultValues: getDefaultFilterMessage(),
  });

  const { handleSubmit, reset, getValues } = formMethods;

  const handleResetForm = () => {
    localStorage.removeItem("IFilterDemandes");
    setSelectedIdstypeDemandes([]);
    setSelectedIdstypeReponses([]);
    setselectedIdsUtilisateurscalipse([]);
    changeFilter(getDefaultFilterMessage());
    reset(getDefaultFilterMessage()); // Réinitialise explicitement le formulaire
  };

  const handleSubmitForm = () => {
    handleSubmit(onSubmit)();
  };

  const onSubmit = (data: IFilterMessage) => {
    const typeDemandes = selectedIdstypeDemandes.map((option: { value: any }) => option.value);
    const typeReponses = selectedIdstypeReponses.map((option: { value: any }) => option.value);
    const idsUtilisateurscalipse = selectedIdsUtilisateurscalipse.map((option: { value: any }) => option.value);
    const combinedData: IFilterMessage = {
      ...data,
      IdTypeDemandes: typeDemandes,
      IdTypereponses: typeReponses,
      IdsUtilisateurscalipse: idsUtilisateurscalipse,
    };
    changeFilter(combinedData);
    localStorage.setItem("IFilterDemandes",JSON.stringify(combinedData)); //needed ??
  };


  const handleKeyPress = (e: { key: string; preventDefault: () => void; }) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      //SubmitButton.current.click();
    }
  };
  const mappedOptionsUtilisateurscalipse = Utilisateurscalipse?.Utilisateurscalipse?.map((tc) => {
    return {
      Id: tc.Id,
      Libelle: tc.NomPrenom,
      //defaultChecked: civ.Id,
    };
  }) || [];

  useEffect(() => {
      if (filter?.IdTypeDemandes) {
        const SelectedIdstypeDemandesValues = typeDemandeMessageListMarques?.concat(typeDemandeMessageListNotices)?.filter((typedemande: { Id: any }) =>
          filter?.IdTypeDemandes?.includes(typedemande.Id)
        ) || [];
        const SelectedIdstypeDemandesValuesList = SelectedIdstypeDemandesValues?.map((demande) => {
          return {
            label: demande.Libelle,
            value: demande.Id,
          };
        });
        setSelectedIdstypeDemandes(SelectedIdstypeDemandesValuesList);
      }
    }, [typeDemandeMessageListMarques]);
    useEffect(() => {
      if (filter?.IdTypereponses) {
        const SelectedIdsTypereponsesValues = typeReponseMessageList?.filter((typereponse: { Id: any }) =>
          filter?.IdTypereponses?.includes(typereponse.Id)
        ) || [];
        const SelectedIdsTypereponsesValuesList = SelectedIdsTypereponsesValues?.map((reponse) => {
          return {
            label: reponse.Libelle,
            value: reponse.Id,
          };
        });
        setSelectedIdstypeReponses(SelectedIdsTypereponsesValuesList);
      }
    }, [typeReponseMessageList]);
    useEffect(() => {
          if (filter?.IdsUtilisateurscalipse) {
            const selectedValues = Utilisateurscalipse?.Utilisateurscalipse?.filter(( Utilisateurscalipse: { Id: any }) =>
              filter?.IdsUtilisateurscalipse?.includes(Utilisateurscalipse.Id)
            ) || [];
      
            // Create an object from selectedValues to map to options
            const selectedValuesList = selectedValues?.map((Utilisateurscalipse : { NomPrenom : any; Id: any }) => {
              return {
                label: Utilisateurscalipse.NomPrenom,
                value: Utilisateurscalipse.Id,
              };
            });
            setselectedIdsUtilisateurscalipse(selectedValuesList);
          }
    }, [Utilisateurscalipse]);
  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} onKeyDown={handleKeyPress} >
        <CpntFormSection pSectionLabel="Filtres">
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6, 6,6,12]}>
          <CpntMultiSelect 
          DefaultLibelle="Sélectionner..."
              options={typeDemandeMessageListMarques?.concat(typeDemandeMessageListNotices)?.map((tc) => {
                return {
                  Id: tc.Id,
                  Libelle: tc.Libelle,
                  //defaultChecked: civ.Id,
                };
              })}
              value={selectedIdstypeDemandes}
              setSelected={setSelectedIdstypeDemandes}
              label="Type de mise à jour"
              ></CpntMultiSelect>
             <CpntMultiSelect 
             DefaultLibelle="Sélectionner..."
             options={typeReponseMessageList?.map((tc) => {
              return {
                Id: tc.Id,
                Libelle: tc.Libelle,
                //defaultChecked: civ.Id,
              };
            })}
              value={selectedIdstypeReponses}
              setSelected={setSelectedIdstypeReponses}
              label="Statut"
              ></CpntMultiSelect>
                          <TextInput
              label="EAN"
              formName="Ean"
              validationStyle={validationMode.none}
              placeholder="EAN"
              />
             <TextInput
              label="Marque"
              formName="LibelleMarque"
              validationStyle={validationMode.none}
              placeholder="Marque"
            />
            <CpntMultiSelect 
             DefaultLibelle="Sélectionner..."
             options={mappedOptionsUtilisateurscalipse}
              value={selectedIdsUtilisateurscalipse}
              setSelected={setselectedIdsUtilisateurscalipse}
              label="Suivi par"
              ></CpntMultiSelect>

            <div></div>
            <CpntFilterButtons  
              resetForm={handleResetForm}
              submitForm={handleSubmitForm}
            />
          </CpntFormSectionContainer>
        </CpntFormSection>
      </form>
    </FormProvider>
  );
};

export default DemandesFilter;
